import { handleActions } from 'redux-actions';

import setViewBox from '../actions/setViewBox';
import setReferenceImage from '../actions/setReferenceImage';
import hoverSeating from '../actions/hoverSeating';
import setWaitingHallUpdate from '../actions/setWaitingHallUpdate';
import setTicketPurchaseDialog from '../actions/setTicketPurchaseDialog';
import mouseDrag from '../actions/mouseDrag';
import mouseDown from '../actions/mouseDown';
import mouseUp from '../actions/mouseUp';
import keyUp from '../actions/keyUp';
import keyDown from '../actions/keyDown';
import mouseMove from '../actions/mouseMove';
import zoomViewBox from '../actions/zoomViewBox';
import mouseClickKeyboardKey from '../actions/mouseClickKeyboardKey';
import setViewBoxSlider from '../actions/setViewBoxSlider';
import focusOnTicketType from '../actions/focusOnTicketType';
import outOfFocusTicketType from '../actions/outOfFocusTicketType';
import setTicketTypes from '../actions/setTicketTypes';
import setReservedTicketTypeForSeats from '../actions/setReservedTicketTypeForSeats';
import setDiscardedTicketTypeForSeats from '../actions/setDiscardedTicketTypeForSeats';

import handleSetViewBox from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/reducers/handleSetViewBox';
import handleSetReferenceImage from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/reducers/handleSetReferenceImage';
import setHoveredSeating from './setHoveredSeating';
import handleSetWaitingHallUpdate from './handleSetWaitingHallUpdate';
import handleSetTicketPurchaseDialog from './handleSetTicketPurchaseDialog';
import handleMouseDrag from './handleMouseDrag';
import handleMouseDown from './handleMouseDown';
import handleMouseUp from './handleMouseUp';
import handleKeyUp from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/reducers/handleKeyUp';
import handleKeyDown from './handleKeyDown';
import handleZoomViewBox from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/reducers/handleZoomViewBox';
import handleMouseMove from './handleMouseMove';
import handleFocusOnTicketType from './handleFocusOnTicketType';
import handleOutOfFocusTicketType from './handleOutOfFocusTicketType';
import handleSetTicketTypes from './handleSetTicketTypes';
import handleReservedTicketTypeForSeats from './handleReservedTicketTypeForSeats';
import handleDiscardedTicketTypeForSeats from './handleDiscardedTicketTypeForSeats';
import handleArrowKeys from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/reducers/handleArrowKeys';
import handleSetViewBoxSlider from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/reducers/handleSetViewBoxSlider';
import { MAX_VIEW_BOX_ZOOM, MIN_VIEW_BOX_ZOOM } from '%paysera_seat_selection/js/seatSelection/config/constants';

export default handleActions(
    {
        [focusOnTicketType]: handleFocusOnTicketType,
        [outOfFocusTicketType]: handleOutOfFocusTicketType,
        [setTicketTypes]: handleSetTicketTypes,
        [setReservedTicketTypeForSeats]: handleReservedTicketTypeForSeats,
        [setDiscardedTicketTypeForSeats]: handleDiscardedTicketTypeForSeats,
        [setViewBox]: handleSetViewBox,
        [setReferenceImage]: handleSetReferenceImage,
        [hoverSeating]: setHoveredSeating,
        [setTicketPurchaseDialog]: handleSetTicketPurchaseDialog,
        [setWaitingHallUpdate]: handleSetWaitingHallUpdate,
        [mouseDown]: handleMouseDown,
        [mouseUp]: handleMouseUp,
        [mouseDrag]: handleMouseDrag,
        [keyUp]: handleKeyUp,
        [keyDown]: handleKeyDown,
        [zoomViewBox]: handleZoomViewBox,
        [mouseMove]: handleMouseMove,
        [mouseClickKeyboardKey]: handleArrowKeys,
        [setViewBoxSlider]: handleSetViewBoxSlider,
    },
    {
        viewBox: {
            coordinates: {
                x: 0,
                y: 0,
            },
            width: 1000,
            height: 1000,
        },
        referenceImage: {
            image: {
                src: null,
                width: null,
                height: null,
                position: { x: 0, y: 0 },
                zoom: 100,
                questionAsked: false,
                configurationOpen: false,
                show: false,
                show_to_buyers: false,
            },
        },
        settings: {
            snapSize: 10,
            snapToGrid: false,
            gridSize: 10,
            showGrid: true,
            showReferenceImage: false,
            showImageToBuyers: false,
        },
        waitingHallUpdate: false,
        mouseDown: null,
        mouseMove: null,
        ticketPurchaseDialog: null,
        modifierKeys: [],
        hoveredSeat: null,
        viewBoxSlider: {
            min: MIN_VIEW_BOX_ZOOM,
            max: MAX_VIEW_BOX_ZOOM,
            step: (MAX_VIEW_BOX_ZOOM - MIN_VIEW_BOX_ZOOM) / 100,
        },
        ticketTypeOnFocus: null,
        ticketTypes: null,
    },
);
